export type CedeError = {
  code: number;
  message: string;
  description: string;
  documentation: string;
};

export interface CedeErrors {
  readonly rpc: {
    readonly parse: CedeError;
    readonly invalidRequest: CedeError;
    readonly methodNotFound: CedeError;
    readonly invalidParams: CedeError;
    readonly internal: CedeError;
  };

  readonly defaultError: CedeError;

  readonly ccxt: {
    readonly baseError: CedeError;
    readonly requestExpired: CedeError;
    // readonly general: {
    //   readonly cexError: CedeError;
    //   readonly cexApiAuthError: CedeError;
    //   readonly cexNotAvailable: CedeError;
    //   readonly cexOnMaintenance: CedeError;
    //   readonly invalidNonce: CedeError;
    //   readonly notSupported: CedeError;
    //   readonly notSupportedNfts: CedeError;
    // };
    // readonly order: {
    //   readonly orderNotFound: CedeError;
    //   readonly orderImmediatelyFillable: CedeError;
    //   readonly orderNotFillable: CedeError;
    //   readonly invalidOrder: CedeError;
    //   readonly duplicateOrderId: CedeError;
    // };
    // readonly request: {
    //   readonly badRequest: CedeError;
    //   readonly requestTimeout: CedeError;
    //   readonly badResponse: CedeError;
    //   readonly rateLimitExceeded: CedeError;
    //   readonly argumentsRequired: CedeError;
    //   readonly nullResponse: CedeError;
    //   readonly ddosProtection: CedeError;
    //   readonly badSymbol: CedeError;
    // };
    // readonly account: {
    //   readonly accountSuspended: CedeError;
    //   readonly permissionDenied: CedeError;
    //   readonly insufficientFunds: CedeError;
    //   readonly invalidAddress: CedeError;
    //   readonly addressPending: CedeError;
    //   readonly cancelPending: CedeError;
    // };
  };

  readonly internal: {
    readonly general: {
      readonly badPassword: CedeError;
    };
    readonly misc: {
      readonly jobs: {
        readonly fetchTransactionHistoryError: CedeError;
        readonly getLastTxUpdateError: CedeError;
      };
      readonly cancelTrackingError: CedeError;
    };
    readonly vault: {
      readonly accountAlreadyExists: CedeError;
      readonly nameExists: CedeError;
      readonly nameCannotBeGenerated: CedeError;
      readonly accountKeysInconsistent: CedeError;
      readonly cannotUnlockStorage: CedeError;
      readonly cannotPersisted: CedeError;
      readonly creationError: CedeError;
      readonly deletionError: CedeError;
      readonly checkApiCredentialsError: CedeError;
      readonly updateApiCredentialsError: CedeError;
      readonly updateCexSettingsError: CedeError;
      readonly accountCreationError: CedeError;
      readonly accountUpdateError: CedeError;
      readonly globalUnlockError: CedeError;
      readonly notWhitelisted: CedeError;
      readonly accountKeyAlreadyExists: CedeError;
      readonly whitelistCheckFail: CedeError;
    };
  };

  readonly cede: {
    readonly general: {
      readonly notSupportedFeature: CedeError;
      readonly dispatcherDefaultError: CedeError;
      readonly approvalNotFound: CedeError;
      readonly vaultNotAllowedToAccess: CedeError;
      readonly accountNotPermission: CedeError;
      readonly accountInvalidSetOfPermissions: CedeError;

      readonly notConnected: CedeError;
      readonly notInitialized: CedeError;
      readonly userDeniedApproval: CedeError;
      readonly methodNotAvailableForThisExchange: CedeError;
      readonly invalidPermissionsSetup: CedeError;
    };
    readonly vault: {
      readonly notFound: CedeError;
      readonly accountNotFound: CedeError;
      readonly fetchVaultsError: CedeError;
      readonly generateAccountNameError: CedeError;
      readonly validateAccountNameError: CedeError;
      readonly updateAccountNameError: CedeError;
      readonly getAccountError: CedeError;
      readonly getAccountsError: CedeError;
      readonly notOAuthAccount: CedeError;
      readonly accountAlreadyContainsApiKeys: CedeError;
    };
    readonly exchange: {
      readonly public: {
        readonly fetchTickerFromTokenError: CedeError;
        readonly serverDown: CedeError;
        readonly underMaintenance: CedeError;
        readonly supportedTokensError: CedeError;
        readonly unavailableInThisCountry: CedeError;
      };
      readonly balances: {
        readonly getBalancesError: CedeError;
        readonly getNftFromCexError: CedeError;
      };
      readonly transactions: {
        readonly getVaultTransactionsError: CedeError;
      };
      readonly deposit: {
        readonly getDepositableTokensError: CedeError;
        readonly getDepositAddressError: CedeError;
      };
      readonly trade: {
        readonly orderNotFound: CedeError;
        readonly postOrderError: CedeError;
        readonly fetchMarketPairsError: CedeError;
        readonly fetchAllTickersFromSymbolsError: CedeError;
        readonly minAmountError: CedeError;
        readonly tickerNotFound: CedeError;
        readonly invalidOrderRequest: CedeError;
        readonly fetchMarketPriceError: CedeError;
        readonly getTradePathError: CedeError;
      };
      readonly network: {
        readonly networkNotFound: CedeError;
        readonly networkNotProvided: CedeError;
        readonly networksNotStandardized: CedeError;
      };
      readonly withdrawal: {
        readonly tokenToDefiAddressError: CedeError;
        readonly tokenToAnotherCexError: CedeError;
        readonly notFound: CedeError;
        readonly infoError: CedeError;
        readonly invalidAddress: CedeError;
      };
      readonly coinbase: {
        readonly accountNotFound: CedeError;
      };
      readonly exchangeInstance: {
        readonly notFound: CedeError;
      };
      readonly authentication: {
        readonly oauthFlowInterruptedByTheUser: CedeError;
      };
      readonly nft: {
        readonly notSupportedNfts: CedeError;
      };
    };
  };

  readonly api: {
    readonly invalidRequest: CedeError;
  };
}
